var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Empty',{staticClass:"empty-custom-image",attrs:{"image":"https://img.yzcdn.cn/vant/custom-empty-image.png","description":_vm.desc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }